"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangesetOrderByProperty = void 0;
/**
 * Changeset entity properties that are supported in $orderBy url parameter which specifies by what property
 * entities are ordered in a collection.
 */
var ChangesetOrderByProperty;
(function (ChangesetOrderByProperty) {
    ChangesetOrderByProperty["Index"] = "index";
})(ChangesetOrderByProperty = exports.ChangesetOrderByProperty || (exports.ChangesetOrderByProperty = {}));
//# sourceMappingURL=ChangesetOperationParams.js.map